module.exports = __webpack_public_path__ + "img/framework_Image.917e3828.png";